import React from 'react';
import { TableVirtuoso  } from 'react-virtuoso';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import {  IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

const RequestPGNRows = ({data,handleRowDelete,handleEditRow}) => {
    const tableHeight = data?.length === 1 ? 240 : data?.length === 2  ? 420 : 600;
    const VirtuosoTableComponents = {
        Scroller: React.forwardRef((props, ref) => (
          <TableContainer component={Paper} {...props} ref={ref} />
        )),
        Table: (props) => (
          <Table {...props} sx={{ borderCollapse: 'separate', tableLayout: 'fixed' }} />
        ),
        TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
        TableRow,
        TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
    };

    const fixedHeaderContent = () => {
        return (
          <TableRow>
            <TableCell style={{ width: '150px' }}>Actions</TableCell>
            {Object.keys(data[0])?.map((column) => (
              <TableCell
                key={column}
                variant="head"
                style={{ width: '130px' }}
              >
                {column}
              </TableCell>
            ))}
          </TableRow>
        );
    }  

    const Row = ({index}) => {
        const row = data[index];
        return (
            <>
                <TableCell>
                    <IconButton 
                        color="inherit" 
                        title="Edit"
                        onClick={()=> handleEditRow(row,index)}
                    >
                        <EditIcon />
                    </IconButton>
                    <IconButton 
                        color="error" 
                        title="Delete"
                        onClick={()=> handleRowDelete(index)}
                    >
                        <DeleteIcon />
                    </IconButton>
                </TableCell>
                {Object.keys(row)?.map((field) => {
                    return (
                        <TableCell key={field}>{row[field]}</TableCell>
                    );
                })}
            </>
        )
    }

    
  return (
    <>
    { data?.length > 0 &&
        <Paper style={{ height:tableHeight,width: '100%' }}>            
            <TableVirtuoso 
                className='TableVirtuoso'
                totalCount={data?.length}
                data={data}
                components={VirtuosoTableComponents}
                fixedHeaderContent={fixedHeaderContent}
                itemContent={(index) => (<Row index={index} />)}
                useWindowScroll={false}
            />   
        </Paper> 
    }
    </>
  )
}

export default RequestPGNRows